(function($) {
	$(document).ready(function() {
		// $('.tribe-events-nav-next a').on('click', function() {

		// });
	});
})(jQuery);